import React, { useState } from "react"
import PropTypes from "prop-types"
import Header from "./Header/header"
import "./layout.scss"
import Footer from "./Footer/footer"
import { NotificationContext } from "gatsby-theme-blank/src/components/notification-context"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { ThemeProvider } from "styled-components"
import { StyledLayout } from "./layout-styled"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fab } from "@fortawesome/free-brands-svg-icons"
import { fas } from "@fortawesome/free-solid-svg-icons"
import { far } from "@fortawesome/free-regular-svg-icons"

//-----------------------Component---------------------------//

const Layout = ({ children, isGdd, isIndex }) => {
  library.add(fab, fas, far)
  const buildColors = useBuildData().theme_settings.palette
  const fontsHeading = useBuildData().theme_settings.typography_heading
  const fontsText = useBuildData().theme_settings.typography_text
  const theme = buildColors
  theme.fontsHeading = fontsHeading
  theme.fontsText = fontsText
  const [isOpen, setIsOpen] = useState(false)

  return (
    <ThemeProvider theme={theme}>
      <NotificationContext.Provider value={{ isOpen, setIsOpen }}>
        <StyledLayout>
          <Header isIndex={isIndex} isGdd={isGdd}>
            {children}
          </Header>
          <Footer></Footer>
        </StyledLayout>
      </NotificationContext.Provider>
    </ThemeProvider>
  )
}
//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  isGdd: PropTypes.bool,
  isIndex: PropTypes.bool,
}
//-----------------------Prop-Types---------------------------//

export default Layout
